module.exports = __webpack_public_path__ + "static/media/correct.fff65908.svg";